import {Component} from '@angular/core';

@Component({
  selector: 'app-payment-page-table',
  templateUrl: './payment-page-table.component.html',
  styleUrls: ['./payment-page-table.component.scss']
})
export class PaymentPageTableComponent {

}
